import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import {Platform} from 'react-native';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Feather from 'react-native-vector-icons/Feather';

import { css } from 'styled-components/native';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const ContentScroll = styled.ScrollView`
  padding: 0 24px;
`;

export const SectionContainer = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const Section = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionHeader = styled.ScrollView.attrs({
  horizontal: true,
  showsHorizontalScrollIndicator: false,
  contentContainerStyle: {
    paddingHorizontal: 24,
    paddingBottom: RFValue(12),
    gap: RFValue(12),
  },
})`

`;

export const SectionHeaderWrapper = styled.View`
  position: relative;
`;

export const SECTION_CHEV_SIZE = RFValue(28);

interface SectionChevBtnProps {
  side: 'left' | 'right';
}

export const SectionChevBtn = styled.TouchableOpacity<SectionChevBtnProps>`
  position: absolute;
  ${({side}) => (side === 'left' ? 'left: 4px;' : 'right: 4px;')}
  top: ${Math.round((RFValue(90) - SECTION_CHEV_SIZE) / 2)}px;
  width: ${SECTION_CHEV_SIZE}px;
  height: ${SECTION_CHEV_SIZE}px;
  border-radius: ${SECTION_CHEV_SIZE / 2}px;
  background-color: rgba(0, 0, 0, 0.28);
  justify-content: center;
  align-items: center;
  z-index: 2;
`;

interface SectionItemProps {
  selected: boolean;
}

interface SectionItemProps {
  selected: boolean;
}

export const SectionItemWrapper = styled.View<SectionItemProps>`
  width: ${RFValue(125)}px;
  height: ${RFValue(90)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({selected, theme}) =>
    selected ? theme.colors.primary : theme.colors.background};
  border:1px solid ${({selected, theme}) =>
    selected ? theme.colors.primary : theme.colors.border2};

  ${({theme}) =>
    Platform.OS === 'ios'
      ? css`
          shadow-color: ${theme.colors.dark_shadow};
          shadow-offset: 0px 4px;
          shadow-opacity: 0.1;
          shadow-radius: 9px;
        `
      : css`
     
        `}
`;

export const SectionItem = styled.TouchableOpacity`
  flex: 1;
  border-radius: ${RFValue(14)}px;
  padding: ${RFValue(12)}px;
  justify-content: space-between;
`;

export const SectionIconBg = styled.View<SectionItemProps>`
  flex-direction: row;
  gap:${RFValue(2)}px;
`;

export const SectionIcon = styled(MaterialCommunityIcons)<SectionItemProps>`
  color: ${({theme, selected}) => selected ? theme.colors.shape : theme.colors.primary};
  font-size: ${RFValue(20)};
`;

export const SectionItemTitle = styled.Text<SectionItemProps>`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
 color: ${({theme, selected}) => selected ? theme.colors.shape : theme.colors.title};
`;

export const SectionTitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(4)}px;
`;

export const SectionCountBadge = styled.View<SectionItemProps>`
  min-width: ${RFValue(16)}px;
  height: ${RFValue(16)}px;
  border-radius: ${RFValue(9)}px;
  background-color: ${({selected, theme}) =>
    selected ? theme.colors.shape : theme.colors.primary};
  align-items: center;
  justify-content: center;
  padding: 0 ${RFValue(4)}px;
`;

export const SectionCountBadgeText = styled.Text<SectionItemProps>`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(9)}px;
  color: ${({selected, theme}) =>
    selected ? theme.colors.primary : theme.colors.shape};
`;


export const SectionTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const VouchersContainer = styled.View`
  margin-top: ${RFValue(6)}px;
`;

export const AboveFormButton = styled.TouchableOpacity`
  align-self: flex-start;
`;
export const AboveFormButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const BannerContainer = styled.View`
  margin: 0 24px;
`;

export const BannerButton = styled.TouchableOpacity`
  margin-top: ${RFValue(12)}px;
`;

//@ts-ignore
export const Banner = styled(FastImage)`
  width: 100%;
  height: ${RFValue(49)}px;
  border-radius: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const NotFoundContainer = styled.View`
  flex: 1;

  height: 100%;
`;

export const ActionsRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin: 0 24px;
  margin-bottom: ${RFValue(6)}px;
`;

export const RefreshButton = styled.TouchableOpacity`
  background-color: #15a118;
  width: ${RFValue(24)}px;
    height: ${RFValue(24)}px;
  border-radius: ${RFValue(28)}px;
  justify-content: center;
  align-items: center;
`;
export const RefreshButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: #222;
`;

export const RefreshButtonIcon = styled(FontAwesome)`
    font-size: ${RFValue(14)}px;
  color: #fff;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  gap: ${RFValue(3)}px;
  align-self: flex-start;
  align-items: center;

`;

export const ButtonSeparator = styled.Text`
  color:${({theme}) => theme.colors.blue};
`;

export const VoucherItemOverlayContainer = styled.View`
  position: relative;
`;

export const VoucherItemOverlay = styled.TouchableOpacity`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: ${RFValue(8)}px 24px;
  background-color: ${({theme}) => theme.colors.mask_coupon};
  justify-content: center;
  align-items: center;
  margin-top: ${RFPercentage(2)}px;
`;

export const VoucherItemOverlayIcon = styled(FontAwesome)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const VoucherItemOverlayText = styled.Text`
  margin-top: ${RFValue(2)}px;
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(11)}px;
  text-align: center;
`;

export const VoucherItemOverlayButton = styled.TouchableOpacity`
  margin-top: ${RFValue(8)}px;
  padding: ${RFValue(4)}px ${RFValue(10)}px;
  border-radius: ${RFValue(20)}px;
  background-color: ${({theme}) => theme.colors.shape};
`;

export const VoucherItemOverlayButtonText = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

// Chip com ícone + label — variante sólida (fundo verde, texto branco)
export const ActionChipSolid = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(36)}px;
  background-color: rgba(23, 183, 15, 1);
  padding-right: ${RFValue(10)}px;
`;
// Chip com ícone + label — variante ghost (fundo transparente, texto verde)
export const ActionChipGhost = styled(ActionChipSolid)`
  background-color: rgba(23,183,15,0.1);
`;

// Botão circular só com ícone (perfil)
export const ProfileButton = styled.TouchableOpacity`
  height: ${RFValue(32)}px;
  width: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  background-color: #222;
  justify-content: center;
  align-items: center;
`;

export const ChipIconBox = styled.View`
  height: ${RFValue(28)}px;
  width: ${RFValue(28)}px;
  justify-content: center;
  align-items: center;
`;

export const ProfileInitials = styled.Text`
  color: rgba(255, 255, 255, 1);
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
`;

// Ícone para chip sólido (branco)
export const ChipIconSolid = styled(FontAwesome)`
  color: #fff;
  font-size: ${RFValue(16)}px;
`;

// Ícone para chip ghost (verde)
export const ChipIconGhost = styled(FontAwesome)`
  color: rgba(21, 161, 24, 1);
  font-size: ${RFValue(13)}px;
`;

// Label para chip sólido (branco)
export const ChipLabelSolid = styled.Text`
  color: #fff;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

// Label para chip ghost (verde)
export const ChipLabelGhost = styled.Text`
  color: rgba(21, 161, 24, 1);
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const ChipArrow = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: rgba(255, 149, 0, 1);
  margin-left: ${RFValue(4)}px;
`;

